// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".chunk." + "c1d384ee3fab68e5253d" + ".css";
};